import Component from './SubHeaderBar.component';

export default Component;
